import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BottomBar from "../BottomBar";
import EarlyUsers from "./EarlyUsers";
import { UserProfle, UserProfleBg } from "./styled";
import ReactGA from "react-ga4";
import UserAccountDescription from "./UserAccountDescription";
import ReferralCode from "./ReferralCode";
import { bottomBarActions } from "../../store/bottomBarSlice";
import ChefListScreen from "../ChefListScreen/Index";
import SwipeLeftIconSvg from "../../assets/ReactSvg/SwipeLeftIconSvg";
import BackBtnSvg from "../../assets/ReactSvg/BackBtnSvg";
import "./userProfile.css"

const Profile = () => {
  const [newScreen, setNewScreen] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    // ReactGA.send({ hitType: "pageview", page: "/profile" });
    ReactGA.event({
      category: "tab",
      action: "profile",
    });
  }, []);
  const user = useSelector(({ auth }) => auth.user);

  return (
    <UserProfle>
      <UserProfleBg>
        {/* <div className="profile-heading">
          <p className="full-name">{user.username}</p>
        </div> */}
        {/* {user.phonenumber && (
          <p className="mobile-number">{user.phonenumber}</p>
        )} */}
        {/* {user.email && <p className="email-address">&bull; {user.email}</p>} */}
        <div>
          <div className="myprofileTopbarWrapper">
            <BackBtnSvg />
            <div className="myprofile-text Satoshi">My profile</div>
          </div>
        </div>
      </UserProfleBg>
      <div style={{ background: "#fff", marginTop: 2 }}>
        <UserAccountDescription />
      </div>
      <BottomBar />
    </UserProfle>
  );
};

export default Profile;
